import React, {useEffect, useState} from 'react';

import {
  Content,
  Container,
  Title,
  Description,
  ModalFooter,
  ModalHeader,
  AvatarContainer,
  AvatarStation,
  ModalForm,
  AvatarName,
  CloseIconButton,
  CloseIcon,
} from './styles';
import {AirbnbRating} from 'react-native-ratings';
import {RFValue} from 'react-native-responsive-fontsize';
import {Button} from '../../Interface/Forms/Buttons/Button';
import {Input} from '../../Interface/Forms/Inputs/Input';

import frentista from '../../../assets/images/frentista.webp';
import {api} from '../../../services/api';

import {RatingDTO} from '../../../dtos/RatingDTO';
import {useIsFocused} from '@react-navigation/native';
import {useAuth} from '../../../context/auth';

export function RatingModal() {
  const [message, setMessage] = useState('');
  const [rate, setRate] = useState(undefined);
  const isFocused = useIsFocused();
  const {isLogged} = useAuth();

  const [showRateModal, setShowRateModal] = useState(false);
  const [ratingData, setRatingData] = useState<RatingDTO>({} as RatingDTO);

  async function fetchRating() {
    await api.get('/avaliacao').then(response => {
      const data: RatingDTO[] = response.data;

      if (data.length >= 1) {
        const last = data[data.length - 1];
        if (last.pula_avaliacao) {
          return;
        }
        setShowRateModal(true);
        setRatingData(last);
      }
    });
  }

  function handleFinishRating() {
    setShowRateModal(false);
  }

  function resetForm() {
    setRate(undefined);
    setMessage('');
  }

  useEffect(() => {
    if (isLogged) {
      fetchRating();
    }
  }, [isLogged]);

  useEffect(() => {
    if (!isFocused) {
      resetForm();
    }
  }, [isFocused]);

  function handleRating() {
    handleRatingSubmit(rate, message, ratingData.cupom_id.$oid);
  }

  async function handleRatingSubmit(number: any, msg: string, id: string) {
    await api
      .get('/avaliaPosto', {
        params: {cupomId: id, pontos: number, relato: msg, avaliou: true},
      })
      .finally(() => {
        handleFinishRating();
      });
  }

  async function handleDismiss() {
    handleFinishRating();
    await api.get('/avaliaPosto', {
      params: {cupomId: ratingData.cupom_id.$oid, avaliou: false},
    });
  }

  return (
    ratingData && (
      <Container isVisible={showRateModal}>
        <Content>
          <CloseIconButton activeOpacity={0.7} onPress={handleDismiss}>
            <CloseIcon name="x" />
          </CloseIconButton>

          <ModalHeader>
            <AvatarContainer source={frentista} />
            <AvatarName>{ratingData.frentista}</AvatarName>
            <AvatarStation>{ratingData.posto_nome}</AvatarStation>
            <AirbnbRating
              count={5}
              showRating={false}
              defaultRating={0}
              size={RFValue(22)}
              onFinishRating={setRate}
            />
          </ModalHeader>

          <Title>Avalie o atendimento</Title>
          <Description>
            Em poucas palavras, descreva como foi sua experiência:
          </Description>

          <ModalForm>
            <Input
              placeholder="Escreva sua avaliação (opcional)"
              value={message}
              onChangeText={setMessage}
            />
          </ModalForm>

          <ModalFooter>
            <Button
              enabled={rate !== undefined}
              onPress={handleRating}
              title="Pronto"
            />
          </ModalFooter>
        </Content>
      </Container>
    )
  );
}
